import React from "react";
import { useTranslation } from "react-i18next";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import submit from "submit-form";

const RemoveMember = ({ cycleId, memberName, memberId, cycleName }) => {
  const { t } = useTranslation("coaching-portal");
  const handleRemove = (cycleId, memberId) => {
    submit(`/actions/cycle/teams-remove-member/${cycleId}/${memberId}`, {
      method: "GET",
    });
  };

  return (
    <ConfirmationModal
      isOpen={true}
      title={t("teams.removeMember.title")}
      contentText={t("teams.removeMember.confirmMessage", {
        memberName,
        cycleName,
      })}
      cancelButtonText={t("teams.removeMember.cancel")}
      cancelButtonAction={() => {
        submit(`/actions/refresh?`, {
          method: "GET",
          body: {
            "modal[type]": "",
            cycleId: "",
            cycleName: "",
            memberName: "",
            memberId: "",
          },
        });
      }}
      confirmButtonText={t("teams.removeMember.confirmButton")}
      confirmButtonAction={() => {
        handleRemove(cycleId, memberId);
      }}
      icon="delete"
      toClear={["cycleId", "cycleName", "memberName", "memberId"]}
    />
  );
};

export default RemoveMember;
